import { Component, Inject, OnInit } from '@angular/core';
import { AnsweredExam } from '../../../models/interfaces/answered_exam.interface';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../core/services/api/api.service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { cloneDeep } from 'lodash-es';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-modal-view-exam-answers',
    imports: [CommonModule, MatIconModule, MatDialogModule, MatExpansionModule, MatProgressSpinnerModule, MatButtonModule],
    templateUrl: './modal-view-exam-answers.component.html',
    styleUrl: './modal-view-exam-answers.component.scss'
})
export class ModalViewExamAnswersComponent implements OnInit {
  examName!: string;
  answeredExams!: Array<AnsweredExam>;
  studentName!: string | null;
  totalQuestions: number = 0;
  requiredQuestions: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalViewExamAnswersComponent>,
    private api: ApiService,
    private toast: ToastService,
    public auth: AuthService
  ) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    if (!receivedData || !receivedData.examName || !receivedData.answeredExams) return this.closeModal();

    this.examName = receivedData.examName;
    this.answeredExams = receivedData.answeredExams;
    this.studentName = receivedData?.studentName;
    this.totalQuestions = receivedData.totalQuestions;
    this.requiredQuestions = receivedData.requiredQuestions;
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  async downloadAnswers(event: any, answeredExam: AnsweredExam): Promise<void> {
    try {
      event.stopPropagation();
      answeredExam.isDownloadingAnswers = true;
      const params: any = { answeredExamId: answeredExam.answeredExamId };
      await this.api.downloadExamAnswers(params);
      answeredExam.isDownloadingAnswers = false;
    } catch (errorResponse: any) {
      answeredExam.isDownloadingAnswers = false;
      const errorMessage = errorResponse?.error?.message;
      this.toast.presentErrorToast(errorMessage || 'Hubo un error descargando respuestas');
    }
  }
}
